export function FeaturedServices() {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <section className="py-20 bg-[#F5F1E8]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Our Most Popular Services
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            These are the services our Owings Mills customers request most frequently
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8">
          <div className="bg-white rounded-3xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 border-t-4 border-[#4A7C2C]">
            <div className="relative h-80">
              <img 
                src="https://public.readdy.ai/ai/img_res/c6d8367199366f737d7fa292c94f80e8.jpg"
                alt="Professional lawn mowing service"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="p-8">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-12 h-12 bg-[#4A7C2C] rounded-full flex items-center justify-center">
                  <i className="ri-scissors-cut-line text-2xl text-white"></i>
                </div>
                <h3 className="text-2xl font-bold text-gray-900">Lawn Mowing</h3>
              </div>
              <p className="text-gray-600 mb-6 leading-relaxed">
                Keep your lawn looking pristine with our professional mowing services. We provide consistent, reliable lawn care that maintains the perfect height and appearance for your grass throughout the growing season. Our experienced crew uses commercial-grade equipment to deliver clean, precise cuts every time.
              </p>
              <ul className="space-y-3 mb-6">
                <li className="flex items-center gap-3 text-gray-700">
                  <i className="ri-check-line text-[#4A7C2C] text-xl"></i>
                  <span>Weekly or bi-weekly scheduling</span>
                </li>
                <li className="flex items-center gap-3 text-gray-700">
                  <i className="ri-check-line text-[#4A7C2C] text-xl"></i>
                  <span>Professional striping patterns</span>
                </li>
                <li className="flex items-center gap-3 text-gray-700">
                  <i className="ri-check-line text-[#4A7C2C] text-xl"></i>
                  <span>Edge trimming included</span>
                </li>
              </ul>
              <button 
                onClick={scrollToContact}
                className="inline-flex items-center gap-2 bg-[#4A7C2C] text-white px-6 py-3 rounded-full font-semibold hover:bg-[#2D5016] transition-all duration-300 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-phone-fill"></i>
                Get Started
              </button>
            </div>
          </div>

          <div className="bg-white rounded-3xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 border-t-4 border-[#4A7C2C]">
            <div className="relative h-80">
              <img 
                src="https://readdy.ai/api/search-image?query=professional%20mulching%20service%20installation%2C%20worker%20spreading%20fresh%20dark%20brown%20mulch%20around%20flower%20beds%20and%20trees%20in%20Maryland%20residential%20landscape%2C%20neat%20edges%2C%20vibrant%20plants%2C%20beautiful%20garden%20design%2C%20high%20quality%20professional%20photography&width=800&height=600&seq=featured-mulching-001&orientation=landscape"
                alt="Professional mulching service"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="p-8">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-12 h-12 bg-[#4A7C2C] rounded-full flex items-center justify-center">
                  <i className="ri-plant-line text-2xl text-white"></i>
                </div>
                <h3 className="text-2xl font-bold text-gray-900">Mulching</h3>
              </div>
              <p className="text-gray-600 mb-6 leading-relaxed">
                Transform your landscape with professional mulch installation. Our mulching services not only enhance your property's curb appeal but also protect your plants, retain moisture, and suppress weeds. We use premium quality mulch and ensure precise, clean installation around all your beds and trees.
              </p>
              <ul className="space-y-3 mb-6">
                <li className="flex items-center gap-3 text-gray-700">
                  <i className="ri-check-line text-[#4A7C2C] text-xl"></i>
                  <span>Premium quality mulch options</span>
                </li>
                <li className="flex items-center gap-3 text-gray-700">
                  <i className="ri-check-line text-[#4A7C2C] text-xl"></i>
                  <span>Weed barrier installation</span>
                </li>
                <li className="flex items-center gap-3 text-gray-700">
                  <i className="ri-check-line text-[#4A7C2C] text-xl"></i>
                  <span>Clean, precise edging</span>
                </li>
              </ul>
              <button 
                onClick={scrollToContact}
                className="inline-flex items-center gap-2 bg-[#4A7C2C] text-white px-6 py-3 rounded-full font-semibold hover:bg-[#2D5016] transition-all duration-300 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-phone-fill"></i>
                Get Started
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
